import { render, staticRenderFns } from "./t-page-form-field-customizable.vue?vue&type=template&id=49d099ea&scoped=true&"
import script from "./t-page-form-field-customizable.vue?vue&type=script&lang=js&"
export * from "./t-page-form-field-customizable.vue?vue&type=script&lang=js&"
import style0 from "./t-page-form-field-customizable.vue?vue&type=style&index=0&id=49d099ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d099ea",
  null
  
)

export default component.exports